import { Spinner, SpinnerSize, Tab } from "@blueprintjs/core";
import * as React from "react";
import { useQuery } from "react-query";
import { useHistory, useParams } from "react-router";

import { LanguageApi } from "../../../../api";
import { BackButton, PageBase, ProtectedTabs } from "../../../../components";
import { ERoutes } from "../../../../ERoutes";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { LanguageDetailPage } from "./LanguageDetailPage";

export interface ILanguageItemPageProps {}

export const LanguageItemPage: React.FunctionComponent<ILanguageItemPageProps> = (props) => {
  const { t } = useTl();
  const { id, tab, state = "edit" } = useParams<{ id: string; tab: string; state: string }>();
  const history = useHistory();
  const api = useApiService(LanguageApi);

  const { data: displayName, isFetching: loadingDislayName } = useQuery(
    "referential-contact-fields",
    React.useCallback(async () => (+id > 0 ? await api.getDisplayName(+id) : t(ETLCodes.New)), [api])
  );

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.Language), route: ERoutes.language },
        { text: loadingDislayName ? <Spinner size={SpinnerSize.SMALL} /> : displayName },
      ]}
    >
      <ProtectedTabs
        id="TabsLanguage"
        onChange={(newTabId) => history.push(`${ERoutes.language}/${id}/${newTabId}/${state}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.language} />
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<LanguageDetailPage languageId={+id} edit={state === "edit"} />}
        />
      </ProtectedTabs>
    </PageBase>
  );
};
